<template>
  <div class="dialog-content">

    <el-dialog title="裁判选择" :visible.sync="isShow" @close="onClose">
      <el-input placeholder="请输关键字搜索" v-model="keywords" @input="onSearch"><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
      <div style="margin: 10px 0">可选列表</div>
      <div class="picker-cell-group" v-if="options.length>0">
        <div class="picker-cell" v-for="(item, index) in options" :v-if="index < limit">
            <el-checkbox :value="item.checked"  @change="toggle(item)">{{item.name}}({{(item.sex==1? '男':'女')+' '+item.num}})</el-checkbox>
        </div>
      </div>
      <div v-else>
        没有记录...
      </div>


      <div slot="footer" class="dialog-footer">
        <el-button @click="memberAdd">新增裁判员</el-button>
        <el-button type="primary" @click="onConfirm">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="新增裁判员" :visible.sync="addShow" @close="addShow = false">
      <el-form
          :model="formData"
          ref="ruleForm"
          :rules="rules"
          label-width="120px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input
                  type="text"
                  placeholder="请输入姓名"
                  v-model="formData.name"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件类型" prop="type">
              <el-radio-group v-model="formData.cardtype">
                <el-radio :label="1">身份证</el-radio>
                <el-radio :label="2">护照</el-radio>
                <el-radio :label="3">其他身份证明</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="num" v-if="formData.cardtype==1">
              <el-input
                  type="text"
                  placeholder="请输入身份证号"
                  v-model="formData.num"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formData.cardtype!=1">
            <el-form-item label="证件号码" prop="huzhao">
              <el-input
                  type="text"
                  placeholder="请输入证件号码"
                  v-model="formData.huzhao"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="phone">
              <el-input
                  type="text"
                  placeholder="请输入手机号"
                  v-model="formData.phone"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="裁判证书编号" prop="cert_no">
              <el-input
                  type="text"
                  placeholder="请输入裁判证书编号"
                  v-model="formData.cert_no"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="裁判证书等级" prop="cert_grade">
              <el-input
                  type="text"
                  placeholder="请输入裁判证书等级"
                  v-model="formData.cert_grade"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="微信号" prop="weixin">
              <el-input
                  type="text"
                  placeholder="请输入微信号"
                  v-model="formData.weixin"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">保存
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import validator from "../../utils/validator";

export default {
  name: "CaipanPicker",
  props: {
    show: {
      type: Boolean,
      default: false
    },

    danweiId: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 1
    },

    defaultValue: {
      type: Array,
      default: () => []
    },

  },
  data() {
    return {
      isShow: false,
      addShow:false,
      showDate: false,
      result: [],
      list:[],
      keywords: "",
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(2015, 0, 1),
      showNumTypePicker:false,
      numTypeColumns: ['身份证', '护照','其他身份证明'],
      actions:[
        { name: '隐藏' },
        { name: '认证' },
      ],
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        namekey: [{ required: true, message: "请选择省市", trigger: "blur" }],
        area: [{ required: true, message: "请选择地区", trigger: "blur" }],
        address: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
        nickname: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        num: [
          { required: true, message: "请输入正确的身份证号", trigger: "blur" },
          { validator: validator.idCard, trigger: "blur" },
        ],
        huzhao: [
          { required: true, message: "证件号码不能为空", trigger: "blur" },
        ],
        cert_no: [
          { required: true, message: "请输入裁判证书编号", trigger: "blur" },
        ],
        cert_grade: [
          { required: true, message: "请输入裁判证书等级", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入正确的手机号", trigger: "blur" },
          { validator: validator.phone, trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入正确的邮箱", trigger: "blur" },
          { validator: validator.email, trigger: "blur" },
        ],
      },
      formData:{
        name:'',
        num:'',
        huzhao:'',
        cardtype:1,
        numTypeName:'身份证',
        phone:'',
        email:'',
        qq:'',
        weixin:'',
        cert_no:'',
        cert_grade:'',
      },
      saveLoading:false,
    };
  },
  computed:{
    options(){
      let that = this;
      this.list.map((item,index) =>{
        if(that.resultIds.indexOf(item.num) ==-1){
          item.checked = false;
        }else{
          item.checked = true;
        }
      })

      return [...this.list];
    },
    resultIds(){
      return this.result.map((item,index) =>{
        return item.num
      })
    },

    showBirthday(){
      return this.formData.cardtype !=1 ;
    },
    showSex(){
      return this.formData.cardtype !=1 ;
    },
  },
  mounted() {
  },
  watch: {
    show(value) {
      this.isShow = value;
      if(value){
        this.onSearch();
        this.result = [...this.defaultValue];
      }
    },
    result(value){
      this.$emit("onChange",value);
    },

  },
  methods: {
    onClose() {
      this.$emit("onClose");
    },

    toggle(item) {
      console.log('toggle',item.checked);
      if(!item.checked){
        //选中
        if(this.limit ==1 ){
          //单选
          this.options.map(item=>{
            item.checked = false;
          })
          this.result = [];
        }else{
          //多选
          if(this.result.length >= this.limit ){
            this.$message.info('最多不能超过'+(this.limit)+'个');
            return ;
          }

        }

      }
      item.checked =!item.checked ;
      if(item.checked){
        //add
        this.result.push(item);
      }else{
        //pen
        this.result = this.result.filter(val =>{
          return val.id != item.id
        });
      }
    },
    onSearch() {
      let that = this;
      that.$api.get(
              "/api/caipan/caipanOptions",
              { keywords: this.keywords,danwei_id:that.danweiId },
        res => {
          that.list = [...res.data];
        }
      );
    },

    onConfirm() {
      let that = this;
      console.log(that.result);
      that.$emit("onConfirm", that.result);
      that.isShow = false;
    },

    memberAdd(){
      this.addShow = true;
    },

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称
      console.log(that.formData)
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.saveLoading = true;
          that.$api.post("/api/caipan/add", that.formData, (res) => {
            that.saveLoading = false;
            that.addShow = false;
            that.onSearch();
            that.formData = {
              name:'',
              num:'',
              huzhao:'',
              cardtype:1,
              numTypeName:'身份证',
              phone:'',
              email:'',
              qq:'',
              weixin:'',
              cert_no:'',
              cert_grade:'',
            };
          }, (rs) => {
            that.$message.error(rs.msg)
            that.saveLoading = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    onDateConfirm(date){
      console.log('onDateConfirm',date);
      this.showDate = false;
      this.formData.birthday =  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    submit(){

    },
    onNumTypeConfirm(value, index){
      this.formData.numTypeName = value;
      this.formData.cardtype = index+1;
      this.showNumTypePicker = false;
    },
    onFailed(errorInfo){
      console.log('failed', errorInfo);
    },
    onSubmit(values){
      console.log('onSubmit-values',values);
      console.log('submitType',this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

      }
      that.saveLoading = true;
      that.$api.post('/api/caipan/add', that.formData, (res) => {
        that.saveLoading = false;
        that.addShow = false;
        that.onSearch();
        that.formData = {
          name:'',
          num:'',
          huzhao:'',
          cardtype:1,
          numTypeName:'身份证',
          phone:'',
          email:'',
          qq:'',
          weixin:'',
        };
      }, (res) => {
        this.$message.error(res.msg);
        that.saveLoading = false;
      })
    },
  }
};
</script>

<style scoped>
.contain {
  position: relative;
}
.picker-cell-group {
  margin-top: 10px;
}

.picker-cell {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// CaipanPicker.vue?065f5508